import * as React from 'react';
import { useDispatch } from 'react-redux';
import { useAppSelector } from '../../hooks';
import { resetPulses, sortedPulsesSelector, pulsesEmptySelector } from './pulsesSlice';
import './Sidebar.css';
import { selectedPulseSelector, selectedTypesSelector, setSelectedPulse, setSelectedType } from './selectionSlice';
import { types } from './utils/graph';
export function Sidebar() {
    return (React.createElement("div", { className: "sidebar" },
        React.createElement(Types, null),
        React.createElement(Pulses, null)));
}
function Types() {
    const selectedTypes = useAppSelector(selectedTypesSelector);
    return (React.createElement("fieldset", { className: "type-filter" },
        React.createElement("legend", null, "Filter by type"),
        Object.entries(types).map(([type, { label }]) => (React.createElement(Type, { key: type, type: type, selected: selectedTypes[type], label: label })))));
}
function Type({ type, label, selected }) {
    const dispatch = useDispatch();
    return (React.createElement("div", null,
        React.createElement("input", { type: "checkbox", checked: selected, onChange: (event) => dispatch(setSelectedType({ type, enabled: event.target.checked })) }),
        React.createElement("label", null, label)));
}
function Pulses() {
    return (React.createElement("fieldset", null,
        React.createElement("legend", null, "Filter by pulse"),
        React.createElement("p", null, "Clicking on a pulse filters the nodes to those that were updated in that pulse and displays their values on hover."),
        React.createElement(PulsesButtons, null),
        React.createElement("table", { className: "editor-table" },
            React.createElement("thead", null,
                React.createElement("tr", null,
                    React.createElement("th", null, "Clock"),
                    React.createElement("th", null, "Touched Nodes"))),
            React.createElement(PulsesRows, null))));
}
function PulsesButtons() {
    const dispatch = useDispatch();
    const selectedPulse = useAppSelector(selectedPulseSelector);
    const pulsesEmpty = useAppSelector(pulsesEmptySelector);
    return (React.createElement("div", { className: "buttons" },
        React.createElement("button", { onClick: () => dispatch(setSelectedPulse(null)), disabled: selectedPulse === null }, "Unselect pulse"),
        React.createElement("button", { onClick: () => dispatch(resetPulses()), disabled: pulsesEmpty }, "Clear recorded pulses")));
}
function PulsesRows() {
    const pulses = useAppSelector(sortedPulsesSelector);
    const selectedPulse = useAppSelector(selectedPulseSelector);
    return (React.createElement("tbody", null, pulses.map(({ clock, nValues }) => (React.createElement(MemoPulse, { key: clock, clock: clock, nValues: nValues, isSelected: clock === selectedPulse })))));
}
const MemoPulse = React.memo(Pulse);
function Pulse({ clock, isSelected, nValues }) {
    const dispatch = useDispatch();
    return (React.createElement("tr", { className: isSelected ? 'active-pulse' : '', onClick: () => dispatch(setSelectedPulse(clock)) },
        React.createElement("td", null, clock),
        React.createElement("td", null, nValues)));
}
